export const SET_PROVIDERS = 'SET_PROVIDERS';
export const SET_NEW_PROVIDER = 'SET_NEW_PROVIDER';
export const UPDATE_NEW_PROVIDER = 'UPDATE_NEW_PROVIDER';
export const RESET_NEW_PROVIDER = 'RESET_NEW_PROVIDER';
